module.exports = __webpack_public_path__ + "media/images/bg_support-dc42a8e2bcd7d8a3b952a7d2eceb75cb.jpg";